import { Grid, makeStyles, Theme } from "@material-ui/core";
import { createCurrencyField, createSelectField } from "@roc/ui";
import { servicerFeesOptions } from "libs/feature-loans/src/loans/loanDetails/payoffs/constants/payoffs";
import ServicerFeeStore from "libs/feature-payoffs/stores/servicerFeeStore";
import { observer } from "mobx-react";

const useStyles = makeStyles((theme: Theme) => ({
  formFields: {
    marginTop: '1rem',
  },
  recalculate: {
    marginTop: '2rem',
  },
  radioField: {
    paddingLeft: '10px',
  },
}));

interface Props {
  store: ServicerFeeStore;
}

export const AddServicerForm = observer(({ store }: Props) => {
  const classes = useStyles();

  return (
    <div>
      <Grid container direction="row" justify="space-around">
        <Grid item xs={7}>
          {createSelectField({
              store,
              testId: 'description',
              label: 'Category',
              fieldName: 'description',
              options: servicerFeesOptions
            })}
        </Grid>
        <Grid item xs={7} className={classes.formFields}>
          {createCurrencyField({
              store,
              testId: 'origAmt',
              label: 'Amount',
              fieldName: 'origAmt',
            })}
        </Grid>
      </Grid>
    </div>
  );
});
